import React from 'react'
import { Tooltip } from 'antd'

const PreviewImg = ({ children, src: srcProp, side = 'right', className, style, ...props }) => {
  const src = srcProp ?? React.Children.only(children)?.props?.src
  if (!src) return children

  return (
    <Tooltip
      placement={side}
      zIndex={9999}
      overlayInnerStyle={{ padding: 0, backgroundColor: '#fff', borderRadius: 8, boxShadow: '0px 4px 24px 2px #00000033' }}
      title={
        <div
          className={className}
          style={{ maxWidth: 168, maxHeight: 224, borderRadius: 8, overflow: 'hidden', ...style }}
          onClick={e => e.stopPropagation()}
        >
          <img src={src} alt="preview" style={{ maxWidth: 168, maxHeight: 224, objectFit: 'contain', display: 'block', borderRadius: 8 }} />
        </div>
      }
      mouseEnterDelay={0.1}
      {...props}
    >
      {children}
    </Tooltip>
  )
}

export default PreviewImg
